import { useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Input } from "./ui/input";
import { ShieldCheck, LockKey } from "@phosphor-icons/react";
import { formatUKDateTime } from "../lib/ukdate";

export default function PolicyAudit() {
  const { isSuperAdmin } = useAuth();
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [err, setErr] = useState(false);
  const load = useCallback(() => {
    api.get("/policies/audit/log?limit=200").then((r) => setRows(r.data)).catch(() => setErr(true));
  }, []);
  useEffect(() => { if (isSuperAdmin) load(); }, [isSuperAdmin, load]);

  if (!isSuperAdmin) {
    return <div className="rounded-xl border border-slate-200 bg-slate-50 p-8 text-center" data-testid="audit-denied">
      <LockKey size={28} className="mx-auto text-slate-400 mb-2" />
      <p className="text-sm text-slate-600">The full audit trail is restricted to <b>super administrators</b>.</p></div>;
  }
  const list = rows.filter((r) => !q || `${r.action} ${r.actor} ${r.entity_type} ${r.reason || ""}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="policy-audit">
      <div className="flex items-center gap-2 mb-3">
        <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-full px-2 py-1"><ShieldCheck size={13} /> Super-admin audit</span>
        <Input data-testid="audit-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by action, actor, reason…" className="h-9 max-w-sm" />
      </div>
      {err && <p className="text-sm text-red-600">Could not load audit log.</p>}
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr>
            <th className="text-left px-3 py-2">When</th><th className="text-left px-3 py-2">Actor</th>
            <th className="text-left px-3 py-2">Action</th><th className="text-left px-3 py-2">Entity</th><th className="text-left px-3 py-2">Reason</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {list.map((r) => (
              <tr key={r.id} data-testid={`audit-${r.id}`}>
                <td className="px-3 py-2 text-slate-500 whitespace-nowrap">{formatUKDateTime(r.created_at)}</td>
                <td className="px-3 py-2 text-slate-700">{r.actor}</td>
                <td className="px-3 py-2"><span className="font-mono text-xs bg-slate-100 rounded px-1.5 py-0.5">{r.action}</span></td>
                <td className="px-3 py-2 text-slate-500 text-xs">{r.entity_type}</td>
                <td className="px-3 py-2 text-slate-500 text-xs">{r.reason || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && !err && <p className="text-sm text-slate-400 py-6 text-center">No audit entries.</p>}
      </div>
    </div>
  );
}
